class Wave extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      const parentSection = this.closest(".shopify-section");

      //Add class signaling which direction the section's wave poitns
      parentSection?.classList?.add(
        `shopify-section--has-wave-${this.dataset.direction}`
      );

      //Add to sibblings
      parentSection?.nextSibling?.classList?.add(
        `shopify-section--prev-has-wave-${this.dataset.direction}`
      );
      parentSection?.previousSibling?.classList?.add(
        `shopify-section--next-has-wave-${this.dataset.direction}`
      );
    });
  }
}

export {
  Wave,
};
